import style from './index.scss';
import { Component } from 'preact';
import Modal from 'react-modal';
import { route } from 'preact-router';
import SubHeader from '../layout/subheader/';
import Related from '../related/';

class Spot extends Component {
    state = { error: false, spot: {}, zoom: false, found: [], hasWon: false };
    componentWillMount(props){
    	if (typeof window !== 'undefined'){
    		window.scrollTo(0, 0);
    	}
    	if (this.props.matches && this.props.matches['activity-id']){
    		let basepath = window.location.host.includes('localhost') ? '/' : '/';
    		this.setState({ loading: true });
    		fetch(basepath + 'assets/spot/' + this.props.matches['activity-id'] + '.json')
    			.then((response) => response.json())
    			.then((spotJSON) => {
    				console.log('setting bundle');
    				this.setState({ spot: spotJSON });
    			}).catch((error) => {
    				this.setState({ error: 'Bad Bundle' });
    			});
    	}
    	else {
    		this.setState({ error: 'No Bundle' });
    	}
    }
    setThumbs(){

    }
    componentWillUpdate(props,state){
    	const is_cheating = false;
    	const { imgsrc, data } = state.spot;

    	if (!state.spot){
    		return;
    	}

    	const image = Object.assign({ image: null },data);
    	let clickRadius = 40;
    	if (!!state.spot.data && !!state.spot.data.radius){
    		clickRadius = state.spot.data.radius;
    	}
    	this.canvas = document.getElementById('canvas_game');
    	const canvas = this.canvas;
    	const context = this.canvas.getContext('2d');
    	let onClick;

    	const draw = (context, differences) => {
    		if (image != null && image.image) {
    			context.drawImage(image.image, 0, 0, 1000, image.single ? 1000 : 1332);
    			if (differences != null) {
    				for (let i = 0; i < image.positions.length; i++) {
    					if (differences[i]) {
    						drawCircle(context, image.positions[i].x, image.positions[i].y);
    						if (!image.single){
    							drawCircle(context, image.positions[i].x, image.positions[i].y-(1332/2));
    						}
    					}

    					// xxx yyyy xxx
    					if (!this.tempCanvas){
    						this.tempCanvas = document.createElement('canvas');
    					}
    					if (!this.thumbs){
    						this.thumbs = new Array(image.positions.length);
    					}
    					if (!this.thumbs[i]) {
    						let newCanvas = this.tempCanvas;
    						newCanvas.width = 60;
    						newCanvas.height = 60;
    						let newContext = newCanvas.getContext('2d');
    						newContext.drawImage(this.canvas, image.positions[i].x - 30, image.positions[i].y - 30, 60, 60, 0, 0, 60, 60);
    						let xurl = newCanvas.toDataURL();
    						this.thumbs[i] = xurl;
    					}
    					// xxx yyyy xxx

    				}
    			}
    		}
    	};

    	//Drawing of circle
    	const drawCircle = (context, x, y) => {
    		context.beginPath();
    		context.lineWidth = 3;
    		context.strokeStyle='#FF00ff';
    		context.arc(x, y, clickRadius, 0, 2*Math.PI);
    		context.stroke();
    	};

    	//Function to load images into array
    	const load = (context, callback) => {
    		let img = new Image();
    		img.onload = function() {
    			image.image = img;
    			//Making sure images are loaded before continuing
    			if (callback != null) {
    				callback(context, img);
    			}
    		};
    		let basepath = window.location.host.includes('localhost') ? '/' : '/';
    		img.src = basepath + 'assets/spot/'+imgsrc;
    	};

    	//Distance between two points
    	const getDistance = (x1, y1, x2, y2) => {
    		let x = x1 - x2;
    		let y = y1 - y2;
    		return Math.sqrt(x * x + y * y);
    	};


    	//Main content
    	//Befin game
    	const play = (imageData) => {
    		if (!imageData.positions) return;
    		let level = 0;
    		let image;
    		const loadLevel = () => {
    			image = null;
    			if (!this.state.found.length){
    				this.setState({ found: new Array(imageData.positions.length) });
    			}

    			// let foundAll = this.state.found.filter(f => !!f).length >= imageData.positions.length;
    			// if(foundAll){
    			//     this.setState({hasWon: true});
    			// }

    			let foundArr = this.state.found;
    			if (imageData.is_cheating){
    				foundArr = new Array(imageData.positions.length).fill(true);
    			}

    			load(context, (context, img) => {
    				draw(context, foundArr);
    			});
    		};

    		//Seeing if click is in circle radius

    		const click = (x, y) => {
    			let image = imageData;
    			if (image) {
    				if (y < (1332/2) && !image.single) {
    					y += (1332/2);
    				}

    				let shortestDistance = clickRadius;
    				let index = null;
    				for (var i = 0; i < image.positions.length; i++) {
    					let position = image.positions[i];
    					let distance = getDistance(x, y, position.x, position.y);
    					if (distance <= shortestDistance) {
    						shortestDistance = distance;
    						index = i;
    					}
    				}
    				if (index != null) {
    					let found = Object.assign(this.state.found);
    					found[index] = true;
    					this.setState({ found });
    					draw(context, this.state.found);
    					try {
    						//toastr.clear();
    						//toastr["info"]("Have found: " + image.positions[index].message)
    					}
    					catch (e){}
    				}
    				let finished = true;
    				for (var i = 0; i < image.positions.length; i++) {
    					if (!this.state.found[i]) {
    						finished = false;
    						break;
    					}
    				}
    			}
    		};
    		this.onClick = click;
    		loadLevel(level);
    	};

    	//Playing game!!!
    	play(image);
    }
    canvasClick(ev){
    	if (this.onClick) {
    		const canvas = this.canvas;
    		let client = this.canvas.getBoundingClientRect();
    		let actualWidth = client.width;
    		let actualHeight = client.height;
    		let width = canvas.width;
    		let height = canvas.height;
    		let ax = ev.clientX - client.left;
    		let ay = ev.clientY - client.top;
    		let x = width * ax / actualWidth;
    		let y = height * ay / actualHeight;
    		this.onClick(x, y);
    	}
    }
    playAgain() {
    	// const {spot} = this.state;
    	// if(!!spot.data && !!spot.data.positions){
    	//     // let foundArray = new Array(spot.data.positions.length);
    	//     // this.setState({found:foundArray});
    	//     window.location.reload();
    	// }
    	window.location.reload();
    }
    backGames(){
    	route('/', true);
    }
    renderWinnings(hasWon){
    	if (hasWon){
    		return (
    			<div className="winning">
    				<div className="winning__inner">
    					<h1>You Win!</h1>
    					<button className="button green" onClick={() => this.playAgain()}>Play Again</button>
    					<button className="button blue" onClick={() => this.backGames()}>Back to Games</button>
    				</div>
    			</div>
    		);
    	}
    	return (
    		<div className="winning hidden" />
    	);
    }

    render(){
    	if (this.state.error){
    		return (<h1>Error {this.state.error}</h1>);
    	}
    	const { subheading, toptext, bottomtext } = this.state.spot || {};
    	let templist = Array.from({ length: 20 }, (v, k) => k+1);

    	const { spot,found } = this.state;
    	let matchList = [];
    	let canvasHeight = 1332;
    	let scoreClassName = 'score__list';
    	let isSingle = false;
    	let showThumbs = false;

    	if (spot.data){
    		if (spot.data.positions){
    			matchList = spot.data.positions.map((s,i) => ({
    				message: s.message,
					thumb: s.thumb || false,
    				found: !!found[i]
    			}));
    		}
    		if (spot.data.single){
    			canvasHeight = 1000;
    		}
    		if (spot.data.single){
    			scoreClassName = 'score__list score__list__single';
    			isSingle = true;
    		}
    		if (spot.data.show_thumbs){
    			showThumbs = true;
    		}
    	}
    	// {!!foundAll && (<div><h1>You Won</h1></div>)}
    	let matchesNum = matchList.filter(ml => ml.found).length;
		let basepath = window.location.host.includes('localhost') ? '/' : '/';
    	return (
    		<div className={'spot-game'}>
    			<SubHeader heading={spot.heading} subheading={spot.subheading} />
    			<p dangerouslySetInnerHTML={{ __html: toptext }} />
    			<div className="spot-game__wrapper">
    				<div className={'spot-game__canvas'}>
    					{this.renderWinnings(matchList.length && matchesNum >= matchList.length)}
    					<canvas id="canvas_game" width="1000" height={canvasHeight} onClick={(ev) => {this.canvasClick(ev);}} />
    				</div>
    				<div className="spot-game__score">
    					<h3 className="score__heading">Found {matchesNum}/{matchList.length}</h3>
    					<ul className={scoreClassName}>
    						{
    							matchList.map((ml,i) => {
    								let scoreStyle = {};
									if (ml.thumb){
										scoreStyle.backgroundImage = `url(${basepath}assets/spot/${this.props.matches['activity-id']}/${ml.thumb})`;
										scoreStyle.backgroundSize = `100%`;
									} else if ((ml.found) && this.thumbs && !!this.thumbs[i]){
    									scoreStyle.backgroundImage = `url(${this.thumbs[i]})`;
    								}
    								let msg = isSingle ? ml.message : (ml.found ? ml.message : 'Not Found Yet');
    								let imgNum = isSingle ? '' : (ml.found ? '' : (i+1));
    								return (
    									<li className={(ml.found ? 'active' : 'inactive')}>
    										<div className="score__image" style={scoreStyle}>{imgNum}</div>
    										<span className={'score__text '}>{msg}</span>
    									</li>
    								);
    							})
    						}
    					</ul>
    				</div>
    			</div>
    			<p dangerouslySetInnerHTML={{ __html: bottomtext }} />

    			<Related related={spot.related} />

    		</div>
    	);
    }
}

export default Spot;



// WEBPACK FOOTER //
// ./components/spot/index.js